module.exports = __webpack_public_path__ + "static/media/arrowUpGreen.559df9ad.svg";